(function () {
  /* ── Identity data ──────────────────────────── */
  const IDS = [
    {
      id: 'leader', name: 'The Leader', icon: '👑',
      tagline: 'Power. Presence. Authority.',
      desc: 'You walk in and rooms take notice. Sharp silhouettes built for people born to lead.',
      url: '/collections/the-leader',
      color: '#1E0E62', glow: '#6B47DC'
    },
    {
      id: 'creator', name: 'The Creator', icon: '🎨',
      tagline: 'Express. Create. Define.',
      desc: 'Your mind builds worlds and your style reflects them. Artistic, layered, unmistakably you.',
      url: '/collections/the-creator',
      color: '#8B0057', glow: '#FF006E'
    },
    {
      id: 'free-spirit', name: 'The Free Spirit', icon: '🌿',
      tagline: 'Breathe. Flow. Be Free.',
      desc: 'Unbothered, effortless, at ease everywhere. Comfort elevated into something beautiful.',
      url: '/collections/the-free-spirit',
      color: '#0A3D2E', glow: '#00C853'
    },
    {
      id: 'rebel', name: 'The Rebel', icon: '⚡',
      tagline: 'Break Rules. Set Trends.',
      desc: 'Rules are suggestions. Edges are everything. You write the trends — never follow them.',
      url: '/collections/the-rebel',
      color: '#1A1A1A', glow: '#FF3D00'
    },
    {
      id: 'romantic', name: 'The Romantic', icon: '🌸',
      tagline: 'Soft. Bold. Beautiful.',
      desc: 'Soft textures, delicate details, warmth in every seam. You dress like beauty matters — because it does.',
      url: '/collections/the-romantic',
      color: '#5C0A2E', glow: '#FF4081'
    },
    {
      id: 'explorer', name: 'The Explorer', icon: '✈️',
      tagline: 'Move. Explore. Arrive.',
      desc: 'Every city is a runway. Versatile and packable — effortlessly stylish from 30,000 feet to street level.',
      url: '/collections/the-explorer',
      color: '#012A5C', glow: '#00B0FF'
    },
    {
      id: 'statement', name: 'The Statement', icon: '🔥',
      tagline: 'One Look. All Eyes.',
      desc: "One piece. One look. The whole room. For the moments when blending in isn't even an option.",
      url: '/collections/the-statement',
      color: '#5C1A00', glow: '#FF6D00'
    }
  ];

  const QS = [
    {
      q: 'Your weekend energy?',
      opts: [
        { em: '🏆', label: 'Making moves',    id: 'leader'      },
        { em: '🎭', label: 'Creating freely',  id: 'creator'     },
        { em: '🛋️', label: 'Total chill',      id: 'free-spirit' },
        { em: '🚀', label: 'Surprise me',      id: 'rebel'       },
        { em: '🌹', label: 'Romantic plans',   id: 'romantic'    },
        { em: '🗺️', label: 'New adventures',   id: 'explorer'    }
      ]
    },
    {
      q: 'Your go-to outfit?',
      opts: [
        { em: '🖤', label: 'Sharp & tailored',  id: 'leader'      },
        { em: '🎨', label: 'Bold & unique',      id: 'creator'     },
        { em: '🌾', label: 'Soft & relaxed',     id: 'free-spirit' },
        { em: '🔩', label: 'Edgy & dark',        id: 'rebel'       },
        { em: '🌸', label: 'Soft & delicate',    id: 'romantic'    },
        { em: '🎒', label: 'Versatile & easy',   id: 'explorer'    }
      ]
    },
    {
      q: 'Friends call you...',
      opts: [
        { em: '💼', label: 'The boss',         id: 'leader'      },
        { em: '🖌️', label: 'The artist',       id: 'creator'     },
        { em: '🌊', label: 'The free one',      id: 'free-spirit' },
        { em: '😈', label: 'The wild card',     id: 'rebel'       },
        { em: '💫', label: 'The showstopper',   id: 'statement'   },
        { em: '🧭', label: 'The adventurer',    id: 'explorer'    }
      ]
    },
    {
      q: 'Pick your mood right now:',
      opts: [
        { em: '⚡', label: 'I run this',        id: 'leader'      },
        { em: '🌈', label: 'Wild & vibrant',    id: 'creator'     },
        { em: '☁️', label: 'Free & breezy',     id: 'free-spirit' },
        { em: '🔥', label: 'Untamed energy',    id: 'rebel'       },
        { em: '🌺', label: 'Soft & glowing',    id: 'romantic'    },
        { em: '🌍', label: 'Ready to explore',  id: 'explorer'    }
      ]
    }
  ];

  let qIdx = 0, scores = {}, result = null, spinning = false;

  const overlay   = document.getElementById('fyl-overlay');
  const trigger   = document.getElementById('fyl-trigger');
  const closeBtn  = document.getElementById('fyl-close');
  const startBtn  = document.getElementById('fyl-start');
  const spinBtn   = document.getElementById('fyl-spin-btn');
  const retakeBtn = document.getElementById('fyl-retake');
  const sIntro    = document.getElementById('fyl-intro');
  const sQuiz     = document.getElementById('fyl-quiz');
  const sSpin     = document.getElementById('fyl-spin');
  const sResult   = document.getElementById('fyl-result');

  if (!overlay || !trigger) return;

  function show(step) {
    [sIntro, sQuiz, sSpin, sResult].forEach(s => s.classList.add('fyl-step--hidden'));
    step.classList.remove('fyl-step--hidden');
  }

  function open() {
    reset();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    show(sIntro);
  }

  function close() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function reset() {
    qIdx = 0; result = null; spinning = false;
    scores = {};
    IDS.forEach(id => { scores[id.id] = 0; });
  }

  function renderQ() {
    const q = QS[qIdx];
    document.getElementById('fyl-q-num').textContent = `${qIdx + 1} / ${QS.length}`;
    document.getElementById('fyl-q-text').textContent = q.q;
    document.getElementById('fyl-progress-bar').style.width = `${(qIdx / QS.length) * 100}%`;

    const wrap = document.getElementById('fyl-options');
    wrap.innerHTML = '';
    wrap.className = 'fyl-options' + (q.opts.length === 6 ? ' fyl-options--3col' : '');

    q.opts.forEach(opt => {
      const btn = document.createElement('button');
      btn.className = 'fyl-option';
      btn.innerHTML = `<span class="fyl-option__em">${opt.em}</span><span>${opt.label}</span>`;
      btn.addEventListener('click', () => pick(opt.id, btn));
      wrap.appendChild(btn);
    });
  }

  function pick(id, btn) {
    document.querySelectorAll('.fyl-option').forEach(b => b.classList.remove('is-selected'));
    btn.classList.add('is-selected');
    scores[id] = (scores[id] || 0) + 1;

    setTimeout(() => {
      qIdx++;
      if (qIdx < QS.length) {
        renderQ();
      } else {
        document.getElementById('fyl-progress-bar').style.width = '100%';
        result = IDS.reduce((best, id) =>
          (scores[id.id] || 0) > (scores[best.id] || 0) ? id : best
        , IDS[0]);
        setTimeout(() => {
          show(sSpin);
          drawWheel(0);
          setTimeout(spin, 1500);
        }, 300);
      }
    }, 320);
  }

  function drawWheel(rotateDeg) {
    const canvas = document.getElementById('fyl-wheel');
    const isMobile = window.innerWidth < 520;
    const size = isMobile ? 300 : 460;
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    const cx = size / 2, cy = size / 2, r = cx - 6;
    const slice = (2 * Math.PI) / IDS.length;
    const rot = rotateDeg * Math.PI / 180 - Math.PI / 2;

    ctx.clearRect(0, 0, size, size);

    IDS.forEach((id, i) => {
      const a0 = rot + i * slice;
      const a1 = a0 + slice;
      const mid = a0 + slice / 2;

      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.arc(cx, cy, r, a0, a1);
      ctx.closePath();

      const grd = ctx.createRadialGradient(
        cx + Math.cos(mid) * r * 0.4,
        cy + Math.sin(mid) * r * 0.4,
        r * 0.05, cx, cy, r
      );
      grd.addColorStop(0, id.glow + 'cc');
      grd.addColorStop(1, id.color);
      ctx.fillStyle = grd;
      ctx.fill();
      ctx.strokeStyle = 'rgba(0,0,0,0.35)';
      ctx.lineWidth = 2;
      ctx.stroke();

      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate(mid);
      ctx.font = `${isMobile ? 18 : 22}px serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(id.icon, r * 0.7, 0);
      ctx.restore();

      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate(mid);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = 'rgba(255,255,255,0.9)';
      ctx.font = `bold ${isMobile ? 8 : 10}px 'Plus Jakarta Sans', sans-serif`;
      ctx.shadowColor = 'rgba(0,0,0,0.5)';
      ctx.shadowBlur = 4;
      ctx.fillText(id.name.replace('The ', ''), r * 0.38, 0);
      ctx.restore();
    });

    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, 2 * Math.PI);
    ctx.strokeStyle = 'rgba(255,255,255,0.12)';
    ctx.lineWidth = 4;
    ctx.stroke();

    const hub = ctx.createRadialGradient(cx, cy, 0, cx, cy, 28);
    hub.addColorStop(0, '#333');
    hub.addColorStop(1, '#111');
    ctx.beginPath();
    ctx.arc(cx, cy, 28, 0, 2 * Math.PI);
    ctx.fillStyle = hub;
    ctx.fill();
    ctx.strokeStyle = 'rgba(255,255,255,0.15)';
    ctx.lineWidth = 2;
    ctx.stroke();

    ctx.beginPath();
    ctx.arc(cx, cy, 7, 0, 2 * Math.PI);
    ctx.fillStyle = 'white';
    ctx.fill();
  }

  function spin() {
    if (spinning || !result) return;
    spinning = true;
    spinBtn.disabled = true;
    spinBtn.textContent = '🎡 Revealing your look…';
    document.getElementById('fyl-spin-title').textContent = 'Watch your look emerge…';

    const idx = IDS.findIndex(id => id.id === result.id);
    const sliceDeg = 360 / IDS.length;
    const targetMid = idx * sliceDeg + sliceDeg / 2;
    const finalAngle = 6 * 360 + (360 - targetMid);
    const dur = 4500;
    const t0 = performance.now();

    function frame(now) {
      const p = Math.min((now - t0) / dur, 1);
      const e = 1 - Math.pow(1 - p, 4);
      drawWheel(e * finalAngle);
      if (p < 1) { requestAnimationFrame(frame); }
      else        { setTimeout(showResult, 700); }
    }
    requestAnimationFrame(frame);
  }

  function showResult() {
    const id = result;
    document.getElementById('fyl-result-icon').textContent    = id.icon;
    document.getElementById('fyl-result-name').textContent    = id.name;
    document.getElementById('fyl-result-tagline').textContent = id.tagline;
    document.getElementById('fyl-result-desc').textContent    = id.desc;
    const cta = document.getElementById('fyl-result-cta');
    cta.textContent = `Shop ${id.name}`;
    cta.href = id.url;
    show(sResult);
  }

  trigger.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  startBtn.addEventListener('click', () => { reset(); show(sQuiz); renderQ(); });
  spinBtn.addEventListener('click', spin);
  retakeBtn.addEventListener('click', () => { reset(); show(sIntro); });
})();
